"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _GroupedTable = _interopRequireDefault(require("./CampaignCreator/FindPersonas/GroupedTable"));

var _CharacteristicsFilterTagList = _interopRequireDefault(require("./CampaignCreator/CharacteristicsFilterTagList"));

var _CampaignPersonaFilterTagList = _interopRequireDefault(require("../containers/CampaignCreator/CampaignPersonaFilterTagList"));

var _helpers = require("../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var GroupedTab = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(GroupedTab, _React$Component);

  function GroupedTab() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = GroupedTab.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        tagId = _this$props.tagId,
        selectedCharacteristics = _this$props.selectedCharacteristics,
        loadGrouped = _this$props.loadGrouped;

    if (selectedCharacteristics) {
      loadGrouped(tagId);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props2 = this.props,
        tagId = _this$props2.tagId,
        selectedCharacteristics = _this$props2.selectedCharacteristics,
        loadGrouped = _this$props2.loadGrouped;
    var prevSelectedCharacteristics = prevProps.selectedCharacteristics;

    if (selectedCharacteristics !== prevSelectedCharacteristics) {
      loadGrouped(tagId);
    }
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        hideUnselectedPersonas = _this$props3.hideUnselectedPersonas,
        communityColours = _this$props3.communityColours,
        handleHideUnselectedPersonas = _this$props3.handleHideUnselectedPersonas,
        groupedPersonaRecords = _this$props3.groupedPersonaRecords,
        isFetching = _this$props3.isFetching,
        selectedPersonas = _this$props3.selectedPersonas,
        handleSelectPersona = _this$props3.handleSelectPersona,
        filters = _this$props3.filters,
        theme = _this$props3.theme,
        isDataPage = _this$props3.isDataPage;
    var maxScore = 100;

    if (groupedPersonaRecords && groupedPersonaRecords[0]) {
      // use the helper function to find the max score
      maxScore = (0, _helpers.getMaxValue)(groupedPersonaRecords, 'score');
    }

    var dataForRows = groupedPersonaRecords ? Object.values(groupedPersonaRecords) : [];
    return /*#__PURE__*/React.createElement(_semanticUiReact.Tab.Pane, null, !isDataPage && /*#__PURE__*/React.createElement(_CharacteristicsFilterTagList["default"], null), !isDataPage && /*#__PURE__*/React.createElement(_CampaignPersonaFilterTagList["default"], {
      filters: filters,
      theme: theme
    }), /*#__PURE__*/React.createElement(_GroupedTable["default"], {
      hideUnselectedPersonas: hideUnselectedPersonas,
      selectedPersonas: selectedPersonas,
      maxScore: maxScore,
      handleHideUnselectedPersonas: handleHideUnselectedPersonas,
      dataForRows: dataForRows,
      communityColours: communityColours,
      handleSelectPersona: handleSelectPersona,
      isFetching: isFetching
    }));
  };

  return GroupedTab;
}(React.Component);

exports["default"] = GroupedTab;